import { Component, OnInit,  Input, ViewContainerRef, ViewChild, ElementRef, TemplateRef, Output, EventEmitter} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
// import { HotToastService } from '@ngneat/hot-toast';
// import {Observable} from 'rxjs/Rx';






import { MysqlService } from './../../../services/mysql.service';

import { BsModalService } from 'ngx-bootstrap/modal';


import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';
import { SystemLogTypeDataSector } from 'src/app/shared/models/systemLogTypeDataSector.model';
import { AppRoute } from 'src/app/shared/models/appRoute.model';
import { DataUtil } from '@syncfusion/ej2-data';
import { TopNavbarComponent } from 'src/app/components/common/topnavbar/topnavbar.component';

@Component({
  selector: 'app-app-route-helper-player-widget',
  templateUrl: './app-route-helper-player-widget.component.html',
  styleUrls: ['./app-route-helper-player-widget.component.scss']
})
export class AppRouteHelperPlayerWidgetComponent implements OnInit {
  [x: string]: Object;


  
  @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef;
  isPlay: boolean = false;
  video_name: string;
    show_route_id: any;
  modalRef: any;
  toggleVideo(event: any) {
  this.videoplayer.nativeElement.play();
  }
  
  @Output('toggleShow') toggleShow: EventEmitter<any> = new EventEmitter();
  
    
     // setup as observable?
     @Input() item_id?; // impliments on changes.
     @Input() item_data?; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size?; // side | abstract | full
    @Input() current_field_name?;
  
    @Input() promotion_id: number;
    @Input() current_route: any;
  
    all_router_details: string;
    system_automation_id: number;
    nav: any;
    system_automation: any;
    brand_types: Object;
    subject_com_types: Object;
    job_types: Object;
    system_log_type_automation_triggers: Object;
    system_log_type: Object;
    system_log_type_data_sectors: Object;
    array_of_triggers: any;
    system_subject_template_docs_automations: any;
    system_subject_template_docs_automations_commuications: any;
    system_log_type_data_sector_conditions: any;
    allFileAutomations: any;
    allCommunicationsAutomations: any;
    allConditionsAutomations: any;
    model: AppRoute;
    log_type_data_sector_id: number;
    system_log_type_data_sector: any;
  
    isShow_condition_array = false;
    isShow_condition_array_example = false;
    isShow_condition_array_keys_example = false;
    isShow_condition_array_fields = false;
    isShow_database = false;
    isShow_database_model_angular = false;
    isShow_database_mysql = false;
    app_route_id: any;
    app_route: any;
  
    constructor(
      private _mysqlService: MysqlService,
      private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private _demoService: DemoService,
        vcr: ViewContainerRef,
        private modalService: BsModalService,
        private _location: Location,
        public gfunc: GlobalFunctionsService,
        public toastr: HotToastService,
        private sanitizer: DomSanitizer,
        // lose tabs
        public topNavBar: TopNavbarComponent
  
    ) {
  
  
       // login vars
      // Set and Access login Session Variables
      this.gfunc.setLoginSessionVars(); // set in a global function file
      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
  
      // this.system_automation_id = +this.route.snapshot.paramMap.get('system_automation_id');
      this.app_route_id = +this.route.snapshot.paramMap.get('app_route_id');
  
     }
  
    ngOnInit(): void {
    }
  
  
  // check for changes. to load data.
  ngOnChanges(changes): void  {
   
    this.model = new AppRoute()
    
    
    if (changes.widget_size) {
    this.widget_size = changes.widget_size.currentValue;
        if (this.widget_size == 'condition'){
        this.isShow_condition_array_example = true;
        }
      }
  
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.app_route_id = changes.item_id.currentValue;
     //  this.getBrandById(this.brand_id);
    //  this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing slash
    //  this.getSystemAutomation(this.system_automation_id);
    this.getAppRoute(this.app_route_id);
  
  
  
  // this.getBrandTypes();
  // this.getSubjectComTypes();
  // this.getJobTypes();
      // this.getBrandUser(this.gfunc.sessionUserId);
      // this.getFormUserLevels();
      // this.getBrands();
    }
  
    // if current_route set and changes if this component is included 
  }
  
  
  showAppRouteVideoWidget(app_route_id){
  
    this.topNavBar.toggleShow_help_routes();
  
    // this.show_route_id = app_route_id;
    this.app_route_id = app_route_id;
    // this.getAppRoute(app_route_id);
  }
  
  
  showAppRouteVideoWidgetOnly(app_route_id){
  
    // this.topNavBar.toggleShow_help_routes();
  
    // this.show_route_id = app_route_id;
    this.app_route_id = app_route_id;
    // this.getAppRoute(app_route_id);
    this.app_route = null;
  
    
  
  
  }
  
  
  
  getAppRoute(app_route_id) {
    this._demoService.getAppRoute(app_route_id).subscribe(
       data => { this.app_route = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        // this.getJobTypeLocations(res.job_type_id);
        // this.getJobTypeCourts(res.job_type_location_id);
        // this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  
  
     
   private getSubjectComTypes() {
    this._demoService.getSubjectComTypes()
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }
  
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
    // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
    getHtml(html){
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
  
      // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
    // WORKS as I created my own function from this articel == pretty well convers
    transform2(value: any, args?: any): any {
      const doc = new DOMParser().parseFromString(value, 'text/html');
      return doc.documentElement.textContent;
    }
  
  
  
// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
      // small upgrade to disable background click on open modal background
      const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
      this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};

  
  
makeDuplicateAppRoute(model){
  if (confirm('We are about duplicate this item, Are you Sure?')) {
  // post a new With this model. & Name as copuy
  model.app_route_name =  model.app_route_name + '_COPY'
  if (model.app_route_description != null){model.app_route_description = '_COPY **** of **** ' + model.app_route_description}
  if (model.app_route_notes != null){model.app_route_notes = '_COPY **** of **** ' + model.app_route_notes}
  if (model.app_route_as_actual_NAME != null){model.app_route_as_actual_NAME = model.app_route_as_actual_NAME + '_COPY'}
  if (model.app_route_as_variable != null){ model.app_route_as_variable = model.app_route_as_variable + '_COPY'}
  if (model.app_route_as_variable_NAME != null){model.app_route_as_variable_NAME = model.app_route_as_variable_NAME + '_COPY'}
  if (model.routerLink != null){model.routerLink = '_COPY **** of **** ' + model.routerLink}
  if (model.routerLinkGeneral != null){model.routerLinkGeneral = '_COPY **** of **** ' + model.routerLinkGeneral}
  if (model.help_content != null){model.help_content = '_COPY **** of **** ' + model.help_content}
  if (model.help_content_HTML != null){model.help_content_HTML = '_COPY **** of **** ' + model.help_content_HTML}
  if (model.video_content != null){model.video_content = '_COPY **** of **** ' + model.video_content}
  if (model.guided_tour_content != null){model.guided_tour_content = '_COPY **** of **** ' + model.guided_tour_content}
  model.app_route_1  = '';
  model.app_route_2  = '';
  model.app_route_3  = '';
  model.app_route_4  = '';
  model.app_route_5  = '';
  model.help_content_HTML  = '';
  model.help_content  = '';
  model.video_content  = '';
  model.guided_tour_content  = '';

  // model.is_active = '';
  this.createAppRoute(model);

  }
}
createAppRoute(model) {
  // console.log(model);
    this._demoService.createAppRoute(model).subscribe(
          data => {  this.get_latest_app_route_id = data; // this is the retuned json upon creation.

          this.toastr.success('App Route Added!');
           
  /*
          // tslint:disable-next-line:max-line-length
          this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
          this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
  */
          // this.closeParentModel.emit();
        //   CreateJobTypeComponent.returned.next(false);
            //  return true;
          },
          error => {
            this.toastr.error('Adding App Route Failed :: Please try again!');
            // console.log(Observable.throw(error));
            // return Observable.throw(error);
          console.error(error);
          }
    );
    }

  
  }
  